export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "608bcf91fee01884de41.worker.js");
}
